'use strict';

angular.module('jv.services', ['App.ajax.service'])
    .service('Reqs', ['App', '$http', '$filter', 'TextUtil', 'makeAjaxCall', '$window',
        function(App, $http, $filter,TextUtil, makeAjaxCall, $window) {
        var data = {},
            quickViews = {},
            interviews = {},
            jvUrls = window.jvUrls,
            reqObjRestBaseUrl = jvUrls.jhire + '/action/requisition/',
            reqDetailsRestBaseUrl = jvUrls.jhire + '/action/requisitionDetails',
            reqListRestBaseUrl = jvUrls.jhire + '/action/requisitions',
            applicationRestBaseUrl = jvUrls.jhire + '/action/application/',
            automationEngineBaseUrl = jvUrls.jhire + '/action/automation-engine/',
            userInfoUrl = jvUrls.admin + '/action/user',
            vonqAuthUrl = jvUrls.jhire + '/action/company/';

        function createRequestObject(args, callback, options, onError) {
            var _args = {
                headers : {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            };
            callback = (callback || angular.noop);
            var requestObj = args || _args;
            requestObj.ajaxtype = options.ajaxtype;
            requestObj.url = options.url;
            requestObj.requestType = options.requestType || 'GET';
            requestObj.cache = options.cache || false;
            var params = $.extend({}, options.params) || {};
            for (var key in params) {
                if (Object.hasOwnProperty.call(params, key)) {
                    requestObj[key] = params[key];
                }
            }
            var requestPromise = makeAjaxCall(requestObj);
            requestPromise.then(function(results) {
                callback(results.data, results.status);
            }, function(error){
                if(onError){
                    onError(error);
                }
            });
        }

        function getUrlSearchParams(stringUrl) {
            var url = new URL(stringUrl || $window.location.href);
            var resultObj = {};
            url.searchParams.forEach(function(val, key) {
                resultObj[key] = val;
            });
            return resultObj;
        }

        /**
         *
         * @returns {boolean}
         */
        function validate(data) {
            // TODO: scope.titleField not available
            /*
            var title = data[scope.titleField];
                if( !$.trim(title)){
                    return false;
                }*/

            return true;
        }

        function formatter(data) {
            var terms = {};
            angular.forEach(data, function(value) {
                terms[value.eid] = value.firstName + ' ' + value.lastName;
                if (value.email) {
                    terms[value.eid] += ' [' + value.email + ']';
                }
            });
            return terms;
        }

        /**
         * Serializes the model property(result) to be posted to a remote server.
         * Multiple select values(eg:Checkboxes) are serialized separately
         * and concatenated to the result string.
         *
         * @returns {String} Serialized representation of the model which can be used as a query string for Ajax/Http requests.
         */
        function serialize(data) {
            var checkBoxes = data.CheckBox,
                checkBoxResult = [],
                dropDowns = data.DropDown,
                dropDownResult = [],
                employees = data.Array,
                employeesResult = [],
                emp = data.Employee,
                empResult = [];
            var otherLocations = data.otherLocations,
                otherLocationResult = [];
            //UI posts undefined if the value has been removed from a textbox. Hence, we have to replace undefined with empty quotes to make the property empty
            angular.forEach(data, function(value, key) {
                if (value === undefined) {
                    data[key] = '';
                }
            });


            angular.forEach(otherLocations, function(otherLocation, fieldId) {
                if(angular.isObject(otherLocation)){
                    otherLocationResult.push({
                        'name': 'secondaryLocations',
                        'value': otherLocation.EId
                    });
                }else{
                    otherLocationResult.push({
                        'name': 'secondaryLocations',
                        'value': otherLocation
                    });
                }
            });

            angular.forEach(checkBoxes, function(checkBoxValues, fieldId) {
                angular.forEach(checkBoxValues, function(cbValue, cbKey) {
                    if (cbValue) {
                        checkBoxResult.push({
                            'name': fieldId,
                            'value': cbKey
                        });
                    } else {
                        // Updating a checked to unchecked, server needs to know
                        checkBoxResult.push({
                            'name': fieldId,
                            'value': ''
                        });
                    }
                });
            });
            angular.forEach(employees, function(employeeValues, fieldId) {
                if (employeeValues && angular.isArray(employeeValues) && !emp[fieldId] && emp[fieldId] !== null) {
                    angular.forEach(employeeValues, function(employeeMultiple) {
                        if (employeeMultiple) {
                            /* ==========================================================================
                            Bug #17408 - SM
                            * employeeMultiple possible values are object, string. Preventing undefined by "".
                            * Only Locked field's values are string or array of strings.
                            ========================================================================== */
                            employeesResult.push({
                                'name': fieldId,
                                'value': employeeMultiple.EId || employeeMultiple || ''
                            });
                        }
                    });
                }
            });
            angular.forEach(dropDowns, function(dropDownValue, fieldId) {
                if (dropDownValue !== undefined) {
                    var value;
                    if (angular.isObject(dropDownValue)) {
                        value = dropDownValue.key;
                    } else {
                        value = (dropDownValue === null) ? '' : dropDownValue;
                    }
                    dropDownResult.push({
                        'name': fieldId,
                        'value': value
                    });
                } else {
                    dropDownResult.push({
                        'name': fieldId,
                        'value': ''
                    });
                }
            });

            angular.forEach(emp, function(empValue, fieldId) {
                if (empValue) {
                    empResult.push({
                        'name': fieldId,
                        'value': empValue.EId
                    });
                } else {
                    empResult.push({
                        'name': fieldId,
                        'value': ''
                    });
                }
            });

            // jQuery param() does not serialize Date objects, its a bug. (Quick fix for 9321 - No risk at 11th hour)
            // Other way to handle this(without changing the ui-date directive) would be to have a 'Date' namespace like 'CheckBox', Array etc.
            angular.forEach(data, function(obj, fieldId) {
                if (obj instanceof Date) {
                    data[fieldId] = obj.getMonth() + 1 + '/' + obj.getDate() + '/' + obj.getFullYear();
                } else if(angular.isDefined(obj) && obj.currencyCode){
                    data[fieldId] = JSON.stringify(obj);
                }
            });


            // Reducing the overhead for $.param
            data.CheckBox = {};
            data.Array = {};
            data.Employee = {};
            data.DropDown = {};
            data.otherLocations = {};
            return $.param(data, true) + '&' + $.param(checkBoxResult) + '&' + $.param(employeesResult) + '&' + $.param(empResult) + '&' + $.param(dropDownResult) + '&' + $.param(otherLocationResult);
        }

        function mapEmploymentType(value) {
			switch (value) {
			  case 'Full-Time':
              case 'Part-Time':
				return 'permanent';
              case 'Contractor':
                return 'fixed_term';
              case 'Intern':
                return 'internship';
              case 'ContractToPermanent':
                return 'fixed_term_with_option_for_permanent';
              case 'Temporary':
              case 'TemporaryToPermanent':
              case 'ConversionToRFT':
                return 'temporary';
			}
		}

		function mapWeeklyWorkingHoursFrom(jobType) {
			switch (jobType) {
			  case 'Full-Time':
				return 40;
			  default:
				return 0;
			}
		}

		function mapWeeklyWorkingHoursTo(jobType) {
			switch (jobType) {
			  case 'Full-Time':
				return 40;
			  default:
				return 0;
			}
		}

        function populateSourceTrackingParams() {
            window.hapi.orderJourney.state.utmCodesStepData = {
                ...window.hapi.orderJourney.state.utmCodesStepData.value,
                settings: [
                    {
                        mapToName: true, value: '', key: '__jvss'
                    },
                    {
                        mapToName: false, value: 'VONQ', key: '__jvsd'
                    },
                    {
                        mapToName: false, value: 'JobBoard', key: '__jvst'
                    }
                ]
            };
        }

        function addQueryParamsToUrl(baseUrl,params){
            var url = new URL(baseUrl);
            var queryParams = new URLSearchParams();
            for (var [key, value] of Object.entries(params)) {
                queryParams.append(key, value);
            }
            url.search = queryParams.toString();

            return url.toString();
        }

        var Reqs = {
            primaryHM: function() {
                var config = {
                    formatSelection: function(item) {
                        return item.text + ' (Primary)';
                    }
                };
                return config;
            },

            employeeSelect: function(fieldId, fieldObject, userIds, templateEId) {
                var url = userInfoUrl + '/search?';
                if (fieldId) {
                    url += '&fieldId=' + fieldId;
                }
                if (templateEId) {
                    url += '&templateEId=' + templateEId;
                }
                var pageSize = 50;

                var config = {
                    id: 'EId',
                    ajax: {
                        url: function() {
                            return url;
                        },
                        quietMillis: 100,
                        data: function(term, page) {
                            pageSize = term && 10 || 50;
                            var result = {
                                q: term,
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true
                            };
                            if (fieldObject && angular.isFunction(userIds) && !angular.isUndefined(fieldObject.mappedValues)) {
                                result.ids = userIds(fieldObject);
                            }
                            return result;
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var more = (pageSize * page) < data.employeesCount;
                            return {
                                results: data.employees,
                                more: more
                            };
                        }
                    },
                    formatResult: function(employee) {
                        return '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong>' + employee.email;
                    },
                    formatSelection: function(employee) {
                        return employee.fullName;
                    },
                    initSelection: function(element, callback) {
                        var data;
                        if (fieldObject.data && fieldObject.data.length > 0) {
                            data = fieldObject.data[0];
                        } else {
                            data = false;
                        }
                        callback(data);
                    }
                };
                return config;
            },
            departmentMultiSelect: function(selectionSize) {
                var url = '/admin/action/admin/departments';
                var pageSize = 50;
                var config = {
                    id: 'EId',
                    maximumSelectionSize: selectionSize ? selectionSize : 100,
                    ajax: {
                        url: function() {
                            return url;
                        },
                        quietMillis: 100,
                        data: function(term, page) {
                            pageSize = term && 10 || 50;
                            var result = {
                                name: term,
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true,
                                orderBy: 'name'
                            };
                            return result;
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var more = Boolean(data.count >= (page * data.departments.length) && data.departments.length > 0);
                            return {
                                results: data.departments,
                                more: more
                            };
                        }
                    },
                    formatResult: function(department) {
                        return TextUtil.htmlEncode(department.name);
                    },
                    formatSelection: function(department) {
                        return department.name;
                    },
                    initSelection: function(element, callback) {
                        var url = '/admin/action/admin/departments';
                        url += '?page=0&ids=' + element.val().split(',').join('&ids=');
                        var isMultiple = element.attr('multiple');
                        $.ajax({
                            type: 'GET',
                            url: url,
                            success: function(data) {
                                data = config.ajax.results(data).results;
                                if (!isMultiple) {
                                    if (data.length) {
                                        data = data[0];
                                    } else {
                                        data = false;
                                    }
                                }
                                callback(data);
                            }
                        });
                    }
                };
                return config;
            },

            reqTemplateSelect: function(selectionSize) {
                const url = jvUrls.jhire + '/action/requisition/filter/templates';
                var pageSize = 50;
                const config = {
                    id: 'eid',
                    maximumSelectionSize: selectionSize ? selectionSize : 100,
                    ajax: {
                        url: function() {
                            return url;
                        },
                        quietMillis: 100,
                        data: function(term, page) {
                            pageSize = term && 10 || 50;
                            const result = {
                                name: term,
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true,
                                orderBy: 'templateName'
                            };
                            return result;
                        },
                        results: function (data, page) {
                            const more = Boolean(data.count > (page * data.requisitionTemplates.length) && data.requisitionTemplates.length > 0);
                            if (data.requisitionTemplates && data.requisitionTemplates.length > 0) {
                                Reqs.requisitionTemplatesList = data.requisitionTemplates;
                            }
                            return {
                                results: data.requisitionTemplates,
                                more: more
                            };
                        }
                    },
                    formatResult: function(requisitionTemplates) {
                        return TextUtil.htmlEncode(requisitionTemplates.templateName);
                    },
                    formatSelection: function(requisitionTemplates) {
                        return requisitionTemplates.templateName;
                    },
                    initSelection: function(element, callback) {
                        const isMultiple = element.attr('multiple');
                        $.ajax({
                            type: 'GET',
                            url: url,
                            success: function(data) {
                                data = config.ajax.results(data).results;
                                if (!isMultiple) {
                                    if (data.length) {
                                        data = data[0];
                                    } else {
                                        data = false;
                                    }
                                }
                                callback(data);
                            }
                        });
                    }
                };
                return config;
            },

            locationMultiSelect: function(region, selectionSize, referenceLocation, onlyActive) {
                var url = '/admin/action/company/locations';
                if (angular.isArray(region) && region.length === 1) {
                    url = '/admin/action/admin/locations' + '?regionEId=' + region[0];
                } else if (angular.isArray(region) && region.length > 1) {
                    url = '/admin/action/admin/locations' + '?regionEId=' + region;
                } else if (region) {
                    url = '/admin/action/admin/locations' + '?regionEId=' + region;
                }
                if (referenceLocation) {
                    url += '?refLocation=' + referenceLocation;
                }
                var pageSize = 50;
                var config = {
                    id: 'EId',
                    maximumSelectionSize: selectionSize ? selectionSize : 100,
                    ajax: {
                        url: function() {
                            return url;
                        },
                        quietMillis: 100,
                        data: function(term, page) {
                            pageSize = term && 10 || 50;
                            var result = {
                                name: term,
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true,
                                orderBy: 'name'
                            };
                            if(onlyActive){
                                result.onlyActive = true;
                            }
                            return result;
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                        	var more = Boolean(data.count >= (page * data.locations.length) && data.locations.length > 0);
                        	return {
                                results: data.locations,
                                more: more
                            };
                        }
                    },
                    formatResult: function(location) {
                        return TextUtil.htmlEncode(location.name);
                    },
                    formatSelection: function(location) {
                        return location.name;
                    },
                    initSelection: function(element, callback) {
                        var url = '/admin/action/admin/locations';
                        url += '?page=0&ids=' + element.val().split(',').join('&ids=');
                        var isMultiple = element.attr('multiple');
                        $.ajax({
                            type: 'GET',
                            url: url,
                            success: function(data) {
                                data = config.ajax.results(data).results;
                                if (!isMultiple) {
                                    if (data.length) {
                                        data = data[0];
                                    } else {
                                        data = false;
                                    }
                                }
                                callback(data);
                            }
                        });
                    }
                };
                return config;
            },
            employeeMultipleSelect: function(fieldId, applyHMMRestriction, fieldObj, isPrimaryHM, applyODSRestriction, templateEId) {
                var url = userInfoUrl + '/search?';
                if (fieldId) {
                    url += '&fieldId=' + fieldId;
                }
                if (applyHMMRestriction) {
                    url += '&applyHMMRestriction=' + applyHMMRestriction;
                }
                if (applyODSRestriction && isODSFlagEnabled) {
                    url += '&applyODSRestriction=true';
                }
                if (templateEId) {
                    url += '&templateEId=' + templateEId;
                }
                var pageSize = 50;
                var config = {
                    id: 'EId',
                    ajax: {
                        url: function() {
                            return url;
                        },
                        quietMillis: 100,
                        data: function(term, page) {
                            pageSize = term && 10 || 50;
                            var result = {
                                q: term,
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true
                            };
                            return result;
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var more = Boolean(pageSize <= (data && data.employees && data.employees.length));
                            return {
                                results: data.employees,
                                more: more
                            };
                        }
                    },
                    formatResult: function(employee) {
                        return TextUtil.htmlEncode(employee.fullName);
                    },
                    formatSelection: function(employee) {
                        return employee.fullName;
                    },
                    initSelection: function(element, callback) {
                        var url = config.ajax.url(),
                            isMultiple = element.attr('multiple');
                        var ids = element.val().split(',');
                        if (isMultiple) {
                            url += '&ids=' + element.val();
                        } else {
                            url += '&ids=' + ids.join('&ids=');
                        }
                        url += '&pageSize=' + ids.length;

                        $.ajax({
                            type: 'GET',
                            url: url,
                            success: function(data) {
                                data = config.ajax.results(data).results;
                                if (!isMultiple) {
                                    if (data.length) {
                                        data = data[0];
                                    } else {
                                        data = false;
                                    }
                                }
                                callback(data);
                            }
                        });
                    }
                };
                return config;
            },
            dropDownSelect: function(fieldObject, templateEId) {
                var url = reqObjRestBaseUrl + 'field/' + fieldObject.fieldId + '/values?';
                if (templateEId) {
                    url += '&templateEId=' + templateEId;
                }
                var pageSize;
                if (fieldObject && fieldObject.driver) {
                    url += '&isMapped=' + fieldObject.driver;
                }
                var termForSearch;

                var config = {
                    id: 'key',
                    allowClear: !fieldObject.restrictClear,
                    ajax: {
                        url: url,
                        data: function(term, page) {
                            termForSearch = term;
                            pageSize = term && 10 || 50;
                            var result = {
                                q: term,
                                count: pageSize,
                                offset: page - 1
                            };
                            return result;
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var results, more;
                            if (termForSearch) {
                                results = $filter('filter')(data.fieldValues, {
                                    value: termForSearch
                                });
                                termForSearch = '';
                            } else {
                                results = data.fieldValues;
                            }
                            more = Boolean(pageSize - 2 < (results && results.length));
                            //This condition check is made since some of the dropdown doesn't support pagination as BE send all the data at once
                            /*if(fieldObject && !fieldObject.driver) {
                            	more = false;
                            }*/
                            return {
                                results: results || {},
                                more: more
                            };
                        }
                    },
                    formatResult: function(dropDown) {
                        return TextUtil.htmlEncode(dropDown.value);
                    },
                    formatSelection: function(dropDown) {
                        return dropDown.value;
                    },
                    initSelection: function(element, callback) {
                        var data;
                        if (fieldObject.values && fieldObject.values.length > 0) {
                            data = fieldObject.values[0];
                        } else {
                            data = false;
                        }
                        callback(data);
                    }
                };
                return config;
            },
            getMappedValues: function(fieldObject, getParentValue) {
                var url = reqObjRestBaseUrl + 'field/';
                var pageSize;
                if (fieldObject) {
                    if (fieldObject.parentId) {
                        url += fieldObject.parentId + '/mappedValues?';
                    }
                    if (fieldObject.fieldId) {
                        url += '&fieldIds=' + fieldObject.fieldId;
                    }
                }
                var termForSearch;

                var config = {
                    id: 'key',
                    allowClear: !fieldObject.restrictClear,
                    ajax: {
                        url: url,
                        data: function(term, page) {
                            termForSearch = term;
                            pageSize = term && 10 || 50;
                            var parentValue = getParentValue(fieldObject.parentId);
                            parentValue = angular.isObject(parentValue) ? parentValue.key : parentValue;
                            var result = {
                                q: term,
                                count: pageSize,
                                offset: page - 1
                            };
                            result = $.param(result) + '&value=' + encodeURIComponent(parentValue);
                            return result;
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var result, more;
                            if (termForSearch) {
                                result = $filter('filter')(data.drivenFieldsMappings[fieldObject.fieldId] && data.drivenFieldsMappings[fieldObject.fieldId].values, {
                                    value: termForSearch
                                });
                                termForSearch = '';
                            } else {
                                result = data.drivenFieldsMappings[fieldObject.fieldId] && data.drivenFieldsMappings[fieldObject.fieldId].values;
                            }
                            more = Boolean(pageSize - 2 < (result && result.length));
                            //This condition check is made since some of the dropdown doesn't support pagination as BE send all the data at once
                            if (fieldObject && !fieldObject.parentId) {
                                more = false;
                            }
                            return {
                                results: result || {},
                                more: more
                            };
                        }
                    },
                    formatResult: function(dropDown) {
                        return TextUtil.htmlEncode(dropDown.value);
                    },
                    formatSelection: function(dropDown) {
                        return dropDown.value;
                    },
                    initSelection: function(element, callback) {
                        var data;
                        if (fieldObject.values && fieldObject.values.length > 0) {
                            data = fieldObject.values[0];
                        } else {
                            data = false;
                        }
                        callback(data);
                    }
                };
                return config;
            },
            getFieldMappedEmployees: function(fieldObject, getParentValue) {
                var url = reqObjRestBaseUrl + 'field/';
                var pageSize;
                if (fieldObject) {
                    if (fieldObject.parentId) {
                        url += fieldObject.parentId + '/mappedEmployees?';
                    }
                    if (fieldObject.fieldId) {
                        url += '&fieldIds=' + fieldObject.fieldId;
                    }
                }
                var termForSearch;

                var config = {
                    id: 'EId',
                    ajax: {
                        url: url,
                        data: function(term, page) {
                            termForSearch = term;
                            pageSize = term && 10 || 50;
                            var parentValue = getParentValue(fieldObject.parentId);
                            parentValue = angular.isObject(parentValue) ? parentValue.key : parentValue;
                            var result = {
                                q: term,
                                count: pageSize,
                                offset: page - 1
                            };
                            result = $.param(result) + '&value=' + encodeURIComponent(parentValue);
                            return result;
                        },
                        results: function(data, page) {
                            // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var employees = data.employees;
                            var result, more;
                            result = employees;
                            more = Boolean(pageSize - 2 < (result && result.length));
                            //This condition check is made since some of the dropdown doesn't support pagination as BE send all the data at once
                            if (fieldObject && !fieldObject.parentId) {
                                more = false;
                            }
                            return {
                                results: result || {},
                                more: more
                            };
                        }
                    },
                    formatResult: function(employee) {
                        return '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong>' + employee.email;
                    },
                    formatSelection: function(employee) {
                        return employee.fullName;
                    },
                    initSelection: function(element, callback) {
                        var data;
                        if (fieldObject.data && fieldObject.data.length > 0) {
                            data = fieldObject.data[0];
                        } else {
                            data = false;
                        }
                        callback(data);
                    }
                };
                return config;
            },
            employeeSearch: function() {
                var url = userInfoUrl + '/search?';
                var pageSize = 50;

                var config = {
                    id: 'EId',
                    ajax: {
                        url: url,
                        quietMillis: 100,
                        data: function(term, page) {
                            pageSize = term && 10 || 50;
                            return {
                                q: term,
                                pageSize: pageSize,
                                page: page - 1,
                                fetchMaxSize: true
                            };
                        },
                        results: function(data, page) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var more = (pageSize * page) < data.employeesCount;
                            return {
                                results: data.employees,
                                more: more
                            };
                        }
                    },
                    formatResult: function(employee) {
                        return '<strong>' + TextUtil.htmlEncode(employee.fullName) + '</strong>' + employee.email;
                    },
                    formatSelection: function(employee) {
                        return employee.fullName;
                    },
                    initSelection: function(element, callback) {
                        var url = config.ajax.url,
                            isMultiple = element.attr('multiple');
                        if (isMultiple) {
                            url += '&ids=' + element.val();
                        } else {
                            url += '&ids=' + element.val().split(',').join('&ids=');
                        }

                        $.ajax({
                            type: 'GET',
                            url: url,
                            success: function(data) {
                                data = config.ajax.results(data).results;
                                if (!isMultiple) {
                                    if (data.length) {
                                        data = data[0];
                                    } else {
                                        data = false;
                                    }
                                }
                                callback(data);
                            }
                        });
                    }
                };
                return config;
            },

            candidateSelect: function(jobId) {
                var url = reqObjRestBaseUrl + jobId + '/candidates';
                var pageSize = 50;
                var config = {
                    id: 'EId',
                    ajax: {
                        url: url,
                        contentType: 'application/x-www-form-urlencoded',
                        data: function(term, offset) {
                            var pageSize = term && 10 || 50;
                            offset = term && 1 || 1;
                            return {
                                q: term,
                                count: pageSize,
                                offset: (offset - 1) * pageSize,
                                fetchMaxSize: true
                            };
                        },
                        results: function(data, offset) { // parse the results into the format expected by Select2.
                            // since we are using custom formatting functions we do not need to alter remote JSON data
                            var more = (pageSize * offset) < data.resultCount;
                            return {
                                results: data.resultList,
                                more: more
                            };
                        }
                    },
                    formatResult: function(employee) {
                        return '<strong>' + TextUtil.htmlEncode(employee.firstName + ' ' + employee.lastName) + '</strong>' + employee.email;
                    },
                    formatSelection: function(employee) {
                        return employee.firstName + ' ' + employee.lastName;
                    },
                    initSelection: function(element, callback) {
                        var url = config.ajax.url,
                            isMultiple = element.attr('multiple');
                        if (isMultiple) {
                            url += '&ids=' + element.val();
                        } else {
                            url += '&ids=' + element.val().split(',').join('&ids=');
                        }

                        $.ajax({
                            type: 'GET',
                            url: url,
                            success: function(data) {
                                data = config.ajax.results(data).results;
                                if (!isMultiple) {
                                    if (data.length) {
                                        data = data[0];
                                    } else {
                                        data = false;
                                    }
                                }
                                callback(data);
                            }
                        });
                    }
                };
                return config;
            },
            postOptions: ['Notification', 'AvailableTo', 'Career Site', 'Private', 'Internal Only'],
            filters: function(callback) {
                var options = {
                    'ajaxtype': 'getReqFilters' ,
                    'url': reqListRestBaseUrl + '/filters'
                };

                createRequestObject(null, callback, options);
            },
            list: function(callback, filtersObj, readMode, searchAllReq, forceSearch) {
                var filters = angular.copy(filtersObj);
                var params = '?',
                    multiFields = ['hiringManagerIds', 'recruiterIds', 'regionIds', 'subsidiaryId', 'departmentIds', 'categoryIds', 'jobStateValue', 'typeIds', 'postingType'];
                var temp = {
                    createdDate: filters.createdDate,
                    closedDate: filters.closedDate,
                    filledDate: filters.filledDate,
                    openDate: filters.openDate
                };

                var createDateFields = function(filters, source, dateField) {
                    filters[dateField] = null;
                    //Fire search only if to/from/type is selected.
                    if (temp[dateField] && temp[dateField].type != null && temp[dateField].to != null && temp[dateField].from != null ) {
                        filters[dateField+'To'] = temp[dateField].to;
                        filters[dateField+'From'] = temp[dateField].from;
                        filters[dateField+'Type'] = temp[dateField].type;
                    }
                };

                createDateFields(filters, temp, 'createdDate');
                createDateFields(filters, temp, 'closedDate');
                createDateFields(filters, temp, 'filledDate');
                createDateFields(filters, temp, 'openDate');

                if (data.jobs || forceSearch) {
                    params += 'refreshGrid=refreshGrid&' + App.param(filters);
                }
                if (typeof readMode !== 'undefined') {
                    params += '&readMode=' + readMode;
                }
                if (searchAllReq) {
                    params += '&searchAllReq=true&jobStateValue=1009&sortBy=relevance&q=' + encodeURIComponent(filters.q);
                }

                var options = {
                    'ajaxtype': 'getReqList' ,
                    'url': reqListRestBaseUrl + '/search' + params
                };

                createRequestObject(null, function(response){
                    delete data.jobs;
                    // Only need jobFilters the first time the page loads (defaults)
                    if (data.jobFilter && !filters.clear) {
                        delete response.jobFilter;
                    } else {
                        delete data.jobFilter;
                        // TODO Shouldn't have to pluck items from array
                        angular.forEach(response.jobFilter, function(value, key) {
                            if (angular.isArray(value) && value[0] && $.inArray(key, multiFields) === -1) {
                                value = value[0];
                            }
                            if (value === 'true') {
                                value = true;
                            }
                            if (value === 'false') {
                                value = false;
                            }
                            if (!angular.isArray(value) && !isNaN(value + '')) {
                                value = parseInt(value, 10);
                            }
                            if (value === 'null') {
                                delete response.jobFilter[key];
                            } else {
                                response.jobFilter[key] = value;
                            }
                        });
                    }

                    response?.ColumnHeaders && response?.ColumnHeaders?.sort((a, b) => {
                        return a?.displayOrder - b?.displayOrder;
                    });

                    $.extend(true, data, response);
                    callback(data, forceSearch);
                }, options);
            },
            quickView: function(id, callback) {
                if (quickViews[id]) {
                    callback(quickViews[id]);
                    return;
                }
                var options = {
                    'ajaxtype': 'getReqQuickView' ,
                    'url': reqListRestBaseUrl + '/' + id + '/quickView'
                };

                createRequestObject(null, function(response){
                    quickViews[id] = response;
                    callback(response);
                }, options);
            },
            details: function(options, callback, onErrorCallback) {
                options = angular.extend({
                    fields: null, // Wether or not to include the requisition fields
                    index: null,
                    count: null,
                    id: null
                }, options);
                var url = reqDetailsRestBaseUrl + '?',
                    params;
                if (options.fields) {
                    options.fields = 1;
                } else {
                    options.fields = options.tabs;
                }
                params = {
                    t: options.fields,
                    i: options.index,
                    c: options.count,
                    q: options.query
                };
                if (options.mId) {
                    params.mId = options.mId;
                }
                if (options.readMode) {
                    params.readMode = options.readMode;
                }
                // BE doesn't expect the id to be sent during pagination
                if (!options.paginated) {
                    params.j = options.id && options.id.trim();
                }

                var ajaxOptions = {
                    'ajaxtype': 'getReqDetails' ,
                    'url': url + App.param(params)
                };

                createRequestObject(null, callback, ajaxOptions, onErrorCallback);
            },

            vonqAuth: function(companyEID, callback) {
                var url = vonqAuthUrl;
                if(companyEID){
                    url += companyEID + '/vonq/authentication';
                }
                var ajaxOptions = {
                    'ajaxtype': 'vonqAuth' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            getPaginationCount: function(options, callback) {
                var params = {
                    t: options.fields,
                    i: options.index,
                    c: options.count,
                    q: options.query
                };
                // BE doesn't expect the id to be sent during pagination
                if (!options.paginated) {
                    params.j = options.id && options.id.trim();
                }

                if (options.readMode) {
                    params.readMode = options.readMode;
                }
                // Initializes the pagination array in the backend
                if (params.i && params.j) {

                    var ajaxOptions = {
                        'ajaxtype': 'getReqPaginationCount' ,
                        'url': reqListRestBaseUrl + '/pagination?' + App.param(params)
                    };

                    createRequestObject(null, callback, ajaxOptions);
                }
            },

            getNotesCount: function(reqEId, callback) {
                var ajaxOptions = {
                    'ajaxtype': 'getReqNotesCount' ,
                    'url': reqObjRestBaseUrl + reqEId + '/notes/count'
                };

                createRequestObject(null, callback, ajaxOptions);
            },

            getEstimatedTimeToFill: function(reqEId, callback) {
                var ajaxOptions = {
                    'ajaxtype': 'getReqTTF' ,
                    'url': reqObjRestBaseUrl + reqEId + '/ttf'
                };

                createRequestObject(null, callback, ajaxOptions);
            },

            /**
             * Render form to add/copy new requisition
             *
             * @param copyId {string|falsy} eid of the requisition you wish to copy from
             * @param callback {function} callback function upon XHR success
             */
            add: function(reqEid, callback, options, onErrorCallback) {
                var ajaxOptions = {
                    'ajaxtype': 'addReq' ,
                    'url': reqDetailsRestBaseUrl,
                    params: {
                        t: 3,
                        templateId: getUrlSearchParams().templateId
                    }
                };
                if (reqEid) {
                    ajaxOptions.url = reqObjRestBaseUrl + '{0}/form/copyRequisition'.format(reqEid);
                    $.extend(ajaxOptions.params, {
                        isCopy: true,
                        j: reqEid
                    });
                }

                createRequestObject(null, callback, ajaxOptions, onErrorCallback);
            },
            /**
             * Render form to edit a requisition
             *
             * @param reqId
             * @param callback {function} callback function upon XHR success
             */
            edit: function(reqEId, callback, options, onErrorCallback) {
                var ajaxOptions = {
                    'ajaxtype': 'editReq' ,
                    'url': reqObjRestBaseUrl + reqEId + '/form/editRequisition',
                    params: {
                        readMode: 0,
                        t: 3
                    }
                };

                if (options.mId) {
                    $.extend(ajaxOptions.params, {
                        messageId: options.mId
                    });
                }

                createRequestObject(null, callback, ajaxOptions, onErrorCallback);
            },
            /**
             * Statistics and Analytics block at top of requisition summary
             *
             * @param reqId {string} requisition eid
             */
            analytics: function(reqEId, callback, readMode) {

                var ajaxOptions = {
                    'ajaxtype': 'getReqAnalytics' ,
                    'url': reqObjRestBaseUrl + reqEId + '/analytics'
                };

                if (typeof readMode !== 'undefined') {
                    ajaxOptions.url += '?readMode=' + readMode;
                }
                createRequestObject(null, callback, ajaxOptions);
            },
            /**
             * Update job hiring prediction category
             *
             * @param reqId {string} requisition eid
             * @param jobCategory {string} job category name
             */
            updatedJobHiringPrediction: function(reqEId, jobCategory, callback, readMode) {
                var ajaxOptions = {
                    'ajaxtype': 'updateJobHiringPrediction' ,
                    'url': reqObjRestBaseUrl + reqEId + '/updateJobHiringPrediction?jobCategory=' + encodeURIComponent(jobCategory)
                };

                if (typeof readMode !== 'undefined') {
                    ajaxOptions.url += '?readMode=' + readMode;
                }
                createRequestObject(null, callback, ajaxOptions);
            },
            /**
             * Job Board block on requisition summary
             *
             * @param reqId {string} requisition eid
             * @param callback {function}
             */
            jobBoard: function(reqEId, callback, readMode) {
                var ajaxOptions = {
                    'ajaxtype': 'getReqJobPBoardPost' ,
                    'url': reqObjRestBaseUrl + reqEId + '/jobboardpost'
                };

                if (readMode){
                    ajaxOptions.url += '?readMode=0';
                }

                createRequestObject(null, callback, ajaxOptions);
            },
            /**
             * Retrieves remaining blocks in the requisition summary
             *
             * @param reqId {string} requisition eid
             * @param callback {function}
             */
            summary: function(reqEId, callback, readMode) {
                var ajaxOptions = {
                    'ajaxtype': 'getReqSummary' ,
                    'url': reqObjRestBaseUrl + reqEId + '/summary'
                };

                if (typeof readMode !== 'undefined') {
                    ajaxOptions.url += '?readMode=' + readMode;
                }

                createRequestObject(null, callback, ajaxOptions);
            },

            deleteReq: function(params, callback) {
                var opts = {
                    'ajaxtype': 'deleteReq',
                    'url': reqObjRestBaseUrl + params.id,
                    'requestType': 'DELETE'
                };
                createRequestObject(null, callback, opts);
            },

            /*
             */
            interviewDetails: function(reqEId, interviewId, interviewStatus, callback) {
                if (interviews[interviewId] && interviews.mode == interviewStatus) {
                    callback(interviews[interviewId]);
                    return;
                }
                var getParams = {
                    state: interviewStatus,
                    appIds: interviewId
                };
                var url = reqObjRestBaseUrl + reqEId + '/application/interviews?' + $.param(getParams);

                var ajaxOptions = {
                    'ajaxtype': 'getInterviewDetails' ,
                    'url': url
                };

                createRequestObject(null, function(response){
                    interviews[interviewId] = response;
                    interviews.mode = interviewStatus;
                    callback(response);
                }, ajaxOptions);
            },

            interviewPaginate: function(params, callback) {
                var getParams = {
                    state: params.mode,
                    offset: params.low
                };
                var url = reqObjRestBaseUrl + params.id + '/candidate/interview/summary?' + $.param(getParams);

                var ajaxOptions = {
                    'ajaxtype': 'getInterviewPaginate' ,
                    'url': url
                };

                createRequestObject(null, callback, ajaxOptions);
            },

            save: function(data, params, callback, options) {
                options = angular.extend({
                    error: angular.noop,
                    id: false,
                    validate: true
                }, options);
                var url = jvUrls.jhire + '/action/requisition?';
                // Do not pass id during copy flow
                if (options.id && !options.copyFlow) {
                    url += '&j=' + options.id;
                }
                if (options.validate && !validate(data)) {
                    options.error('invalid');
                    return;
                }
                if (options.readMode) {
                    url += '&readMode=0';
                }
                if (params) {
                    url += params;
                }

                url+='&notifyAgency='+options.notifyAgency;

                data = serialize(data);
                $http({
                    url: url,
                    data: data,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                }).then(callback, options.error);
            },

            linkedInData: function(callback) {
            	var url='/__assets__/scripts/jhire/other/jv.postToLinkedIn_V1.json';
                if(window.isLinkedinV2Enabled === true){
                    url='/__assets__/scripts/jhire/other/jv.postToLinkedIn.json';
                }

                var ajaxOptions = {
                    'ajaxtype': 'getLinkedinData' ,
                    'url': url
                };

                createRequestObject(null, callback, ajaxOptions);
            },

            userEmail: function(reqEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/form/postToLinkedIn';
                var ajaxOptions = {
                    'ajaxtype': 'getUserEmail' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            postToLinkedIn: function(data, jobEId, callback) {
                var opts = {
                    'ajaxtype': 'postToLinkedIn',
                    'url': reqObjRestBaseUrl + jobEId + '/jobboard/LinkedIn',
                    'requestType': 'POST'
                };
               if (jQuery.fn.jquery.split('.')[0] === '3') {
  					 data.traditional = true;
				}
                createRequestObject(data, callback, opts);
            },

            approve: function(options, callback, src, errorCallback = angular.noop) {
                var url = reqListRestBaseUrl + '/approve';
                options = angular.extend({
                    j: '',
                    notes: '',
                    reject: null
                }, options);
                options.notes = options.notes && options.notes.trim() || '';
                if (src && src === 'summary') {
                    url = reqObjRestBaseUrl + options.j + '/workflow/approve?readMode=0';
                    delete options.j;
                }
                var opts = {
                    'ajaxtype': 'approve',
                    'url': url,
                    'requestType': 'POST'
                };
                options.traditional = true;
                createRequestObject(options, callback, opts, errorCallback);
            },

            eQuestData: function(reqEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/jobboard/eQuest';
                var ajaxOptions = {
                    'ajaxtype': 'getEQuestData' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            postToeQuest: function(reqEId, data, callback) {
                var opts = {
                    'ajaxtype': 'postToeQuest',
                    'url': reqObjRestBaseUrl + reqEId + '/jobboard/eQuest?' + $.param(data),
                    'requestType': 'PUT'
                };
                createRequestObject(null, callback, opts);
            },

            submitForApproval: function(reqEId, data, callback) {
                var opts = {
                    'ajaxtype': 'submitForApproval',
                    'url': reqObjRestBaseUrl + reqEId + '/workflow/submitforapproval?readMode=0',
                    'requestType': 'POST'
                };
                createRequestObject(data, callback, opts);
            },

            getApprovers: function(options, callback, mId) {
                var url = reqObjRestBaseUrl + options.reqId + '/form/approvalDetails?';
                if (mId) {
                    url += '&mId=' + mId;
                }
                if (options.hasOwnProperty('readMode')) {
                    url += '&readMode=' + options.readMode;
                }
                var ajaxOptions = {
                    'ajaxtype': 'getApprovers' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            getApprovalChain: function(id, callback, readWrite) {
                var url = reqObjRestBaseUrl + id + '/approvalChain';
                if (!readWrite) {
                    url += '?readMode=0';
                }
                return $http.get(url).then(function(response) {
                    callback((response.data.approvers));
                });
            },
            getApproversHM: function(id, hmId, callback, mId) {
                var url = reqObjRestBaseUrl + id + '/form/approvalDetails?hm=' + hmId + '&readMode=0';
                if (mId) {
                    url += '&mId=' + mId;
                }
                var ajaxOptions = {
                    'ajaxtype': 'getApproversHM' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            notes: function(params, callback) {
                var url = reqObjRestBaseUrl + params.id + '/notes';
                url += '?offset=' + params.offset;
                url += '&count=' + params.count;

                if (params.latest) {
                    url += '&readMode=0';
                }
                var ajaxOptions = {
                    'ajaxtype': 'getNotes' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            addNote: function(jobId, data, callback) {
                data = angular.extend({
                    j: jobId
                }, data);

                if (data && data.to.length > 0) {
                    var toEid = [];
                    angular.forEach(data.to, function(obj, key) {
                        toEid.push(obj.EId);
                    });
                    data.to = toEid;
                }
                if (jQuery.fn.jquery.split('.')[0] === '3') {
                    data.traditional = true;
                }
                if (data && !$.isEmptyObject(data.attachments)) {
                    var attachmentEIds = [];
                    angular.forEach(data.attachments, function(key, value) {
                        if (key.resourceInfo) {
                            attachmentEIds.push(key.resourceInfo.eid);
                        }
                    });
                    data.attachments = null;
                    data.attachments = attachmentEIds.join(',');
                }
                var opts = {
                    'ajaxtype': 'addNote',
                    'url': reqObjRestBaseUrl + data.j + '/note' + '?readMode=0',
                    'requestType': 'POST'
                };
                createRequestObject(data, callback, opts);
            },

            removeFromEQuest: function(reqEId, callback) {
                var opts = {
                    'ajaxtype': 'removeFromEQuest',
                    'url': reqObjRestBaseUrl + reqEId + '/jobboard/eQuest',
                    'requestType': 'DELETE'
                };
                createRequestObject(null, callback, opts);
            },

            skipApprove: function(params, callback) {
                var opts = {
                    'ajaxtype': 'skipApprove',
                    'url': reqObjRestBaseUrl + params.j + '/workflow/skipApproval',
                    'requestType': 'POST'
                };
                createRequestObject(params, callback, opts);
            },

            hold: function(data, callback) {
                var url = reqObjRestBaseUrl + data.id + '/workflow/putOnhold';
                if (data.hasOwnProperty('readMode')) {
                    url += '?readMode=' + data.readMode;
                }
                var opts = {
                    'ajaxtype': 'hold',
                    'url': url,
                    'requestType': 'POST'
                };
                createRequestObject(null, callback, opts);
            },

            post: function(options, callback, readMode) {
                var url = reqObjRestBaseUrl + options.id + '/workflow/post';
                if (options.hasOwnProperty('readMode')) {
                    url += '?readMode=' + options.readMode;
                }
                var opts = {
                    'ajaxtype': 'post',
                    'url': url,
                    'requestType': 'POST'
                };
                createRequestObject(null, callback, opts);
            },

            openToDraft: function(options, callback) {
                var url = reqObjRestBaseUrl + options.id + '/workflow/moveToDraftState';
                if (options.hasOwnProperty('readMode')) {
                    url += '?readMode=' + options.readMode;
                }
                var opts = {
                    'ajaxtype': 'openToDraft',
                    'url': url,
                    'requestType': 'POST'
                };
                createRequestObject(null, callback, opts);
            },

            emailFormatter: function(data) {
                var terms = {};
                angular.forEach(data.employees, function(value) {
                    terms[value.eid] = value.email;
                });
                return terms;
            },

            postToJobTarget: function(reqEId, locationEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/jobboard/JobTarget';
                if (locationEId) {
                    url += '?loc=' + locationEId;
                }

                var options = {
                    'ajaxtype': 'postToJobTarget',
                    'url': url,
                    'requestType': 'POST'
                };
                createRequestObject(null, callback, options);
            },

            modifyJobTargetPosting: function(data, callback) {
                var opts = {
                    'ajaxtype': 'modifyJobTargetPosting',
                    'url': reqObjRestBaseUrl + data.j + '/jobboard/JobTarget?' + $.param(data),
                    'requestType': 'PUT'
                };
                createRequestObject(null, callback, opts);
            },

            removeJobTargetPosting: function(data, callback) {
                var opts = {
                    'ajaxtype': 'removeJobTargetPosting',
                    'url': reqObjRestBaseUrl + data.j + '/jobboard/JobTarget?' + $.param(data),
                    'requestType': 'DELETE'
                };
                createRequestObject(null, callback, opts);
            },

            getExternalApplicants: function(data, callback) {
                return $http.get(reqDetailsRestBaseUrl + '?action=getJobActiveCandidates&j=' + data.jobId + '&q=' + data.query + '&count=10&offset=' + (data.page * 10) + '&fetchMaxSize=true')
                    .then(function(response, code) {
                        response.page = data.page;
                        callback(response, code);
                    });
            },

            getInternalApplicants: function(data, callback) {
                var url = reqDetailsRestBaseUrl + '?action=getEmployees&q=' + data.query + '&pageSize=10&page=' + data.page + '&fetchMaxSize=true';
                var ajaxOptions = {
                    'ajaxtype': 'getInternalApplicants' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            getReqActivity: function(id, count, offset, callback) {
                var url = reqObjRestBaseUrl + id + '/activity?count=' + count + '&offset=' + offset;
                var ajaxOptions = {
                    'ajaxtype': 'getReqActivity' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            getCandAddEditHireForm: function(data, callback) {
                var url = applicationRestBaseUrl + data.appEId + '/state/' + data.stateEId + '/offerAccepted';
                return $http.get(url);
            },

            getAddEditHireForm: function(params, callback) {
                var url = reqObjRestBaseUrl + params.jobEId + '/form/addHireForm';
                if (params.id)
                    {url += '?appId=' + params.id;}
                return $http.get(url);
            },
            candAddHire: function(params, postData, callback) {
                var options = {
                    'ajaxtype': 'candAddHire',
                    'url': applicationRestBaseUrl + params.appEId + '/state/' + params.stateEId + '/offerAccepted',
                    'requestType': 'POST'
                };
                postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(postData, callback, options);
            },

            addHire: function(params, postData, callback) {
                var options = {
                    'ajaxtype': 'addHire',
                    'url': reqObjRestBaseUrl + params.j + '/hire',
                    'requestType': 'POST'
                };
                postData.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(postData, callback, options);
            },

            closeJob: function(reqEId, params, callback) {
                var url = reqObjRestBaseUrl + reqEId + '?close=' + params.close;
                if (params.companyAutomationId) {
                    url += '&companyAutomationId=' + params.companyAutomationId;
                }
                var opts = {
                    'ajaxtype': 'closeJob',
                    'url': url,
                    'requestType': 'PUT'
                };
                params.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(params, callback, opts);
            },

            getApproverMessageTemplate: function(params, callback) {
                var url = reqObjRestBaseUrl + params.jobEId + '/form/resendJobApprovalMessageTemplate?resendToAlternates=' + params.resend;
                var ajaxOptions = {
                    'ajaxtype': 'getApproverMessageTemplate' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            sendApprovalMessage: function(reqEId, postData, callback) {
                var options = {
                    'ajaxtype': 'sendApprovalMessage',
                    'url': reqObjRestBaseUrl + reqEId + '/workflow/resendApproval',
                    'requestType': 'POST'
                };
                createRequestObject(postData, callback, options);
            },

            sendRetractMessage: function(postData, callback, errormet) {
                var options = {
                    'ajaxtype': 'sendRetractMessage',
                    'url': reqObjRestBaseUrl + postData.j + '/workflow/retractApproval',
                    'requestType': 'POST'
                };
                createRequestObject(postData, callback, options, errormet);
            },

            getCandidatestates: function(params, callback) {
                var url = applicationRestBaseUrl + params.reqsAppEId + '/details?readMode=1';
                var ajaxOptions = {
                    'ajaxtype': 'getCandidatestates' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            retractJob: function(data, callback) {
                var url = reqObjRestBaseUrl + data.j + '/form/retractApproval';
                var ajaxOptions = {
                    'ajaxtype': 'retractJob' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            viewCandidateApplications: function(id, callback) {
                var url = applicationRestBaseUrl + id + '/applications';
                var ajaxOptions = {
                    'ajaxtype': 'viewCandidateApplications' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            getRejectCandidateDetails: function(params, callback) {
                var url = applicationRestBaseUrl + params.reqsAppEId + '/reject';
                var ajaxOptions = {
                    'ajaxtype': 'getRejectCandidateDetails' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            rejectCandidate: function(id, data, callback) {
                var options = {
                    'ajaxtype': 'rejectCandidate',
                    'url': applicationRestBaseUrl + id + '/reject',
                    'requestType': 'POST'
                };
                data.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(data, callback, options);
            },
            removeHire: function(params, stateEId, callback) {
                var options = {
                    'ajaxtype': 'removeHire',
                    'url': applicationRestBaseUrl + params.reqsAppEId + '/state/' + stateEId + '/removeHire',
                    'requestType': 'POST'
                };
                createRequestObject(null, callback, options);
            },
            getAndSetMappedValues: function(params, value, fieldId, callback) {
                var url = reqObjRestBaseUrl + 'field/' + fieldId + '/mappedValues?' + params + '&value=' + encodeURIComponent(value) + '&q=&page=0&pageSize=10';
                var ajaxOptions = {
                    'ajaxtype': 'getAndSetMappedValues' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            checkIfLocationChangeValid: function(data, callback) {
                var url = reqObjRestBaseUrl + 'validity/location';
                var ajaxOptions = {
                    'ajaxtype': 'checkIfLocationChangeValid' ,
                    'url': url,
                    'requestType': 'POST'
                };
                data.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(data, callback, ajaxOptions);
            },
            getApplicationId: function(params, callback) {
                var url = reqObjRestBaseUrl + params.jobEId + '/application?userEId=' + params.userEId;
                var ajaxOptions = {
                    'ajaxtype': 'getApplicationId' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            getHireForm: function(params, callback) {
                var url = reqObjRestBaseUrl + params.jobEId + '/form/addHireForm?appId=' + params.appId;
                if (params.readMode) {
                    url += '&readMode=0';
                }
                var ajaxOptions = {
                    'ajaxtype': 'getHireForm' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            getAwaitingApprovalFilter: function(success, error) {
                var url = reqObjRestBaseUrl + 'filter/awaitingApproval';
                var ajaxOptions = {
                    'ajaxtype': 'getAwaitingApprovalFilter' ,
                    'url': url
                };
                createRequestObject(null, success, ajaxOptions);
            },

            getLinkedInJobSyncStatus: function(reqEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/requisitionSyncStatus';
                var ajaxOptions = {
                    'ajaxtype': 'getLinkedInJobSyncStatus' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            syncjobToLinkedIn: function(reqEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/syncJobToLinkedIn';
                var ajaxOptions = {
                    'ajaxtype': 'syncjobToLinkedIn' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            getLinkedInPremiumJobPostStatus: function(reqEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/getLinkedInPremiumJobPostStatus';
                var ajaxOptions = {
                    'ajaxtype': 'getLinkedInPremiumJobPostStatus' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            
            getLinkedInAcJobPostStatus: function(args, callback) {
                var url = reqObjRestBaseUrl + args.reqEId + '/getLinkedInAcJobPostingStatus?resync=' + args.resync;
                var ajaxOptions = {
                    'ajaxtype': 'getLinkedInAcJobPostingStatus' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            getCloseRequisitionForm: function(reqEId, callback){
                var url = reqObjRestBaseUrl + reqEId  + '/form/closeRequisition';
                var ajaxOptions = {
                    'ajaxtype': 'getCloseRequisitionForm' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            getJobLinkSource: function(callback){
                var url = reqObjRestBaseUrl + 'form/createJobLinkSource';
                var ajaxOptions = {
                    'ajaxtype': 'getJobLinkSource' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            createJobBoardSource: function(args, callback, onError) {
                var options = {
                    'ajaxtype': 'createJobBoardSource',
                    'url': jvUrls.jhire + '/action/jobboard/jvAndCrm',
                    'requestType': 'POST'
                };
                var opts = {data: args};
                opts.passAsStringParam = true;
                opts.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(opts, callback, options, onError);
            },

            getTemplates: function(filterParams) {
                $http.get(jvUrls.jhire + '/action/requisition/templates', {
                    params: filterParams
                }).then(function (res) {
                    return (res && res.data);
                });
            },

            getVonqCampaigns: function(reqEId, callback) {
                var url = reqObjRestBaseUrl + reqEId + '/getVonqCampaigns';
                var ajaxOptions = {
                    'ajaxtype': 'getVonqCampaigns' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            registerCampaignOnSuccessEvent : function (callback){
                window.hapi.campaign.service.orderCampaign.onSuccess(callback);
            },

            saveVonqCampaign: function(data, callback) {
                var ajaxOptions = {
                    'ajaxtype': 'saveVonqCampaign',
                    'url': reqObjRestBaseUrl + 'saveVonqCampaign',
                    'requestType': 'POST'
                };
                data.headers = {'Content-Type':'application/json; charset=UTF-8'};
                createRequestObject(data, callback, ajaxOptions);
            },

            /**
             * The following code takes a job object from Jobvite and uses the HAPI Elements SDK to pre-fill the checkout form.
             * Pre-filling is partial, and the user will still need to fill in some fields.
             * Remaining to be mapped:
             * - target group
             * - company logo
             * - working hours
             * - salary
             * - years of experience
             */

            mapJobToHapiElementsCampaignForm: function(job) {
                populateSourceTrackingParams();
                return window.hapi.campaign.state.campaignForm = {
                    ...window.hapi.campaign.state.campaignForm.value,
                    companyId: job.companyEId,
                    targetGroup: { educationLevel: [], seniority: [], industry: [], jobCategory: [] },
                    recruiterInfo: {
                        name: window.userInfo.firstName + ' ' + window.userInfo.lastName,
                        emailAddress: window.userInfo.email
                    },
                    postingDetails: {
                        title: job.title,
                        description: job.description || '',
                        yearsOfExperience: 0,
                        employmentType: mapEmploymentType(job.jobTypeInstance.name),
                        weeklyWorkingHours: { from: mapWeeklyWorkingHoursFrom(job.jobTypeInstance.name), to: mapWeeklyWorkingHoursTo(job.jobTypeInstance.name) },
                        salaryIndication: { period: 'yearly', range: { from: 0, to: 0, currency: 'USD' } },
                        contactInfo: {
                            name: '',
                            emailAddress: '',
                            phoneNumber: ''
                        },
                        organization: { name: companyName, companyLogo: '' },
                        workingLocation: {
                          addressLine1: job.location.address,
                          addressLine2: job.location.address2,
                          city: job.location.city,
                          country: job.location.country,
                          postcode: job.location.postalCode
                        },

                        jobPageUrl: job.jobLinkUrlPath + '&l=' + job.locationEId,
                        applicationUrl: job.jobLinkUrlPath.replace('Job.aspx', 'Careers.aspx').concat('&k=Apply&c=' + job.companyEId + '&l=' + job.locationEId)
                    },
                    orderedProductsSpecs: {},
                    orderedProducts: []
                };
            },
            getAutomations: function(referenceKey, triggerValue, automationType = null, callback){
                var url = automationEngineBaseUrl  + 'rules';
                var params = {
                    'referenceKey': referenceKey,
                    'triggerValue': triggerValue,
                    'automationObject': 'REQUISITION'
                };
                if(automationType !== null){
                    params.automationType = automationType;
                }
                var ajaxOptions = {
                    'ajaxtype': 'getAutomations' ,
                    'url': url,
                    'params': params
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            getTotalAffected: function(referenceKey, triggerValue, callback){
                var url = automationEngineBaseUrl  + 'rules/reference-key-count';
                var ajaxOptions = {
                    'ajaxtype': 'getTotalAffected' ,
                    'url': url,
                    'params': {
                        'referenceKey': referenceKey,
                        'triggerValue': triggerValue,
                    }
                };
                createRequestObject(null, callback, ajaxOptions);
            },
            postRulesTrigger: function(companyAutomationId, referenceKey, triggerType, callback){
                var url = automationEngineBaseUrl  + 'rules/trigger';
                var params = {
                    'companyAutomationId': companyAutomationId,
                    'referenceKey': referenceKey,
                    'triggerType': triggerType
                };

                var urlWithParams = addQueryParamsToUrl(url, params);

                var options = {
                    'ajaxtype': 'postRulesTrigger',
                    'url': urlWithParams,
                    'requestType': 'POST',
                };

                createRequestObject(null, callback, options);
            },

            bulkChangeStatusDropDown: function (callback, errorCallback = angular.noop) {
                const url = `${reqObjRestBaseUrl}list/bulkChangeStatusDropDown`;

                $http.get(url).then((response) => {
                    if (![200, 201]?.includes(response?.status)) {
                        errorCallback(response);
                        return;
                    }
                    callback(response);
                },
                function (error) {
                    errorCallback(error);
                });
            },

            /**
             * Validates the bulk change status data
             *
             * @param {Object} data
             * @returns {Promise}
             */
            validateBulkChangeStatus: function (data) {
                const url = `${reqObjRestBaseUrl}validateChangeStatus`;
                return $http.post(url, data);
            },

            /**
             * Triggers the bulk change status action
             *
             * @param {Object} data
             * @param {function} callback
             * @param {function} errorCallback
             */
            bulkChangeStatus: function (data, callback, errorCallback = angular.noop) {
                const url = `${reqObjRestBaseUrl}list/changeStatus`;

                $http.post(url, data).then((response) => {
                    if (![200, 201]?.includes(response?.status)) {
                        errorCallback(response);
                        return;
                    }
                    callback(response);
                },
                function (error) {
                    errorCallback(error);
                });
            },

            /**
                * Triggers the bulk change status On Selection on selected requisitions
                *
                *
                * @param {Object} data
                * @param {function} callback
                * @param {function} errorCallback
            */
            bulkChangeStatusOnSelection: function (data, callback, errorCallback = angular.noop) {
                const url = `${reqObjRestBaseUrl}bulkChangeStatusOnSelection`;
                $http.post(url,data).then((response) => {
                    if (![200]?.includes(response?.status)) {
                        errorCallback(response);
                        return;
                    }
                    callback(response);
                },
                function (error) {
                    errorCallback(error);
                });
            },


            bulkEditForm: function (data, callback) {
                const opts = {
                    'ajaxtype': 'bulkEditForm',
                    'url': `${reqObjRestBaseUrl}bulkEditForm`,
                    'requestType': 'POST'
                };

                data.headers = {
                    'Content-Type': 'application/json; charset=UTF-8'
                };
                createRequestObject(data, callback, opts);
            },

            getSubmitForApprovalDetail: function(options, callback) {
                let url = `${reqListRestBaseUrl}/form/getSubmitForApprovalDetail?`;

                if (options.hasOwnProperty('readMode')) {
                    url += '&readMode=' + options.readMode;
                }
                const ajaxOptions = {
                    'ajaxtype': 'getApproversForBulkSFA' ,
                    'url': url
                };
                createRequestObject(null, callback, ajaxOptions);
            },

            bulkSubmitForApproval: function (data, callback) {
                const opts = {
                    'ajaxtype': 'bulkSubmitForApproval',
                    'url': `${reqListRestBaseUrl}/workflow/submitForApproval?readMode=0`,
                    'requestType': 'POST'
                };

                data.headers = {
                    'Content-Type': 'application/json; charset=UTF-8'
                };
                createRequestObject(data, callback, opts);
            },

            validateBulkEditFields: function (data, params, callback) {
                data = serialize(data);

                $http({
                    url: `${reqObjRestBaseUrl}validateBulkEditFields?templateEId=${params.templateId}`,
                    data,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                }).then(callback);
            },

            bulkUpdate: function (postData, callback, options) {
                options = angular.extend({
                    error: angular.noop
                }, options);
                const data= serialize(postData.jsonData);
                $http({
                    url: `${reqObjRestBaseUrl}bulkUpdate?readMode=0&${postData.urlParams.join('&')}`,
                    data: data,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                }).then(callback, options.error);
            }

        };
        return Reqs;
    }]);
